import { createTheme } from '@mui/material/styles';
import { palette } from './palette';
import { components } from './components';
import { typography } from './typography';
import { colors } from './colors';
import './assets/fonts/fonts.css';
import ThemeProvider from './ThemeProvider';
var themeName = 'WOM';
var theme = createTheme({
  colors: colors,
  themeName: themeName,
  palette: palette,
  components: components,
  typography: typography,
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 768,
      lg: 1200,
      xl: 1536
    }
  }
});
export { theme as default, ThemeProvider };